var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergyYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 61,
    viewBox: "0 0 45 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3803 56.2786C13.3803 57.0441 13.6994 57.746 14.2736 58.2565L16.8897 60.4258C17.3366 60.8085 17.9107 60.9999 18.4849 60.9999H26.652C27.2262 60.9999 27.8003 60.8085 28.2472 60.4258L30.8634 58.2565C31.4375 57.746 31.7566 57.0441 31.7566 56.2786V51.4932H13.2529L13.2524 56.2786H13.3803Z",
    fill: "#FFF744"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1447 0.512009C10.3188 1.59665 2.34282 9.44462 1.1305 19.271C0.173153 27.8845 4.12939 35.6053 10.5737 39.9441C12.2966 41.0924 13.3171 42.943 13.3171 44.9846V46.7711H31.8208V45.0482C31.8208 43.0704 32.7777 41.1561 34.437 40.0078C40.3071 36.1156 44.1356 29.48 44.1356 21.9507C44.2634 9.25331 33.225 -0.891837 20.1446 0.511895L20.1447 0.512009ZM31.7574 21.9508L20.9105 36.4986C19.9536 37.7746 17.9752 36.8814 18.2943 35.3503L20.2086 25.9708H14.7849C13.5724 25.9708 12.8706 24.5671 13.5724 23.6101L24.4193 9.06235C25.3763 7.78635 27.3546 8.67958 27.0355 10.2106L25.1212 19.5901H30.5449C31.7574 19.5897 32.4592 20.9298 31.7574 21.9508Z",
    fill: "#FFF744"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyYellow);
export default __webpack_public_path__ + "static/media/Energy_Yellow.b0a2ae6d727134ef8583d5b8096523e5.svg";
export { ForwardRef as ReactComponent };